module.exports = __webpack_public_path__ + "static/media/london.0ce6599a.jpg";